import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { Button } from '@etnas/design-system';
import { StateBlock } from '@/components/States';

/** Last-resort boundary: never a blank screen; drafts on the server are safe. */
export function RouteError() {
  const e = useRouteError();
  const msg = isRouteErrorResponse(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : 'Unknown error';
  return (
    <main className="ex-auth" id="main">
      <div className="ex-auth-card">
        <StateBlock kind="error" title="This screen could not be shown" body={`Your saved drafts are safe. Reference: ${msg}`} />
        <Button variant="primary" onClick={() => window.location.assign('/')}>
          Return to my workspace
        </Button>
      </div>
    </main>
  );
}
